export default __webpack_public_path__ + "e196f985.png";